import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=035bf1de"
import script from "./Outbox.vue?vue&type=script&lang=ts"
export * from "./Outbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports